module.exports = __webpack_public_path__ + "static/media/family-rafiki.594e3aab.svg";